/**
 * Service which update values for shopping-cart component.
 */
import { B_FLOW_ID, C_FLOW_ID, PL_FLOW_ID } from '../boilerplate/item-ids';

export default (kasko) => {
  kasko.addEventListener(
    'state-changed',
    (quote) => {
      if (!quote || !quote.data || !quote.data.extraData) {
        return;
      }
      const inputState = kasko.getState().input;
      if (!inputState.shopping_cart_items.length) {
        return;
      }
      const itemA = inputState.shopping_cart_items.find((item) => item.id === C_FLOW_ID);
      const itemAIndex = inputState.shopping_cart_items.findIndex((item) => item.id === C_FLOW_ID);
      const itemB = inputState.shopping_cart_items.find((item) => item.id === PL_FLOW_ID);
      const itemBIndex = inputState.shopping_cart_items.findIndex((item) => item.id === PL_FLOW_ID);
      const itemC = inputState.shopping_cart_items.find((item) => item.id === B_FLOW_ID);
      const itemCIndex = inputState.shopping_cart_items.findIndex((item) => item.id === B_FLOW_ID);

      if (itemA && inputState.contents_finished === true) {
        const shoppingCartItems = inputState.shopping_cart_items;
        shoppingCartItems[itemAIndex].costValue =
          quote.data.extraData.yearly_content_insurance_gross_premium; // eslint-disable-line
        shoppingCartItems[itemAIndex].cost = kasko.getTranslation('flow.contents_item.cost');

        kasko.dispatchEvent('set-form-input', {
          shopping_cart_items: shoppingCartItems,
        });
      }

      if (itemB && inputState.private_liability_finished === true) {
        const shoppingCartItems = inputState.shopping_cart_items;
        shoppingCartItems[itemBIndex].costValue =
          quote.data.extraData.yearly_private_liability_gross_premium; // eslint-disable-line
        shoppingCartItems[itemBIndex].cost = kasko.getTranslation(
          'flow.private_liability_item.cost',
        );

        kasko.dispatchEvent('set-form-input', {
          shopping_cart_items: shoppingCartItems,
        });
      }

      if (itemC && inputState.buildings_finished === true) {
        const shoppingCartItems = inputState.shopping_cart_items;
        shoppingCartItems[itemCIndex].costValue =
          quote.data.extraData.yearly_building_gross_premium; // eslint-disable-line
        shoppingCartItems[itemCIndex].cost = kasko.getTranslation('flow.buildings_item.cost');

        kasko.dispatchEvent('set-form-input', {
          shopping_cart_items: shoppingCartItems,
        });
      }

      kasko.dispatchEvent('write-input', {
        value: inputState.shopping_cart_items.reduce(
          (acc, item) => acc + (item?.costValue || 0),
          0,
        ),
        path: 'shopping_cart_items_total_cost',
        overwrite: true,
      });
    },
    { slice: 'quote' },
  );
};
